import React from 'react';
import Text from '../../../../components/Typography/Text';
import Checkbox from '../../../../components/Misc/Checkbox';
import FormAccountAddress from './FormAccountAddress';
import FormAccountContactAndName from './FormAccountContactAndName';
import RangeSlider from '../../../../components/Misc/RangeSlider';
import LinkButton from '../../../../components/Buttons/LinkButton';
import { useAccountContext } from '../Data/accountContext';

export default function FormAccountOwnerCompany({ objectName, validation, index }) {
  const { account, setAccount, disableUpdate } = useAccountContext();

  const handleChange = (e) => {
    const copy = { ...account };

    const input = e.currentTarget.name ? e.currentTarget : e.target;

    // get object or array index
    if (index !== undefined) {
      copy[objectName][index][input.name] =
        input.type === 'checkbox' ? input.checked : input.value;
    } else {
      copy[objectName][input.name] =
        input.type === 'checkbox' ? input.checked : input.value;
    }

    setAccount({ ...copy });
  };

  const getLabel = (model) => {
    let label = 'Officer/Owner';
    if (model.isOwner && !model.isOfficer) {
      label = 'Owner';
    } else if (model.isOfficer && !model.isOwner) {
      label = 'Officer';
    }
    if (objectName === 'primaryOwner') {
      label = 'Primary ' + label;
    } else {
      label = 'Co-' + label;
    }

    return label;
  };

  // get object or array index
  let validationObject = validation[objectName];
  let modelObject = account[objectName];

  if (index !== undefined) {
    validationObject = validationObject ? validationObject[index] : {};
    modelObject = modelObject[index];
  }

  return (
    <React.Fragment>
      <div className="grd-row mt-50">
        <div className="grd-cell">
          <Text variant="h3" label={getLabel(modelObject)} />
        </div>
        {!disableUpdate && (
          <div className="grd-cell-none">
            <LinkButton
              type="remove"
              label="Remove Officer"
              onClick={() => {
                let copy = { ...account };
                copy.corpOwnersList.splice(index, 1);
                setAccount(copy);
              }}
            />
          </div>
        )}
      </div>
      <div>
        <Text
          required={true}
          error={!!validationObject?.primaryType}
          msg={validationObject?.primaryType}
          mt={20}
          variant="subtitle1"
          label="Primary Type"
        />
        <div className="grd-row">
          <div className="grd-cell-none">
            <Checkbox
              ml={-3}
              name="isOfficer"
              label="Officer"
              checked={modelObject.isOfficer || false}
              onChange={handleChange}
            />
          </div>
          <div className="grd-cell-none">
            <Checkbox
              ml={20}
              name="isOwner"
              label="Owner"
              checked={modelObject.isOwner || false}
              onChange={handleChange}
            />
          </div>
        </div>
        {modelObject.isOwner && (
          <div className="grd-row">
            <div className="grd-cell">
              <RangeSlider
                required={true}
                error={!!validationObject?.ownershipPercent}
                msg={validationObject?.ownershipPercent}
                name="ownershipPercent"
                label="Percentage of Ownership"
                step={1}
                value={parseInt(modelObject.ownershipPercent || 0)}
                onChange={handleChange}
              />
            </div>
          </div>
        )}
      </div>
      <FormAccountContactAndName
        objectName={objectName}
        index={index}
        validation={validation}
      />
      <br />
      <FormAccountAddress
        objectName={
          objectName === 'primaryOwner' ? 'corpPrimaryAgentAddress' : 'corpOwnersList'
        }
        index={index}
        validation={validation}
      />
    </React.Fragment>
  );
}
